import { Seo } from '../components/Seo';
import {Header} from '../components/Header';
import {Footer} from '../components/Footer';

const Terms = () => {

  return (
    <>


      <Seo
        title="title"
        description="descr"
        type="webapp"
      />

      <Header selectedNavitem="about" />

        <p>terms</p>

      <Footer />

    </>
    )
  };
  
  export default Terms;